import React from "react";

export const navigationRef = React.createRef();
export const isReady = React.createRef();

export function navigate(name, params) {
  if (isReady.current && navigationRef.current) {
    navigationRef.current.navigate(name, params);
  }
}
